export default __webpack_public_path__ + "dd6b26175a0ebf8b18837d699e425518.jpg";